import { defineMessages } from 'react-intl'

export const promocodeMessages = defineMessages({
  promocodeInvalid: {
    id: 'promocodeMessages.promocodeInvalid',
    description: 'Message of error when no such promocode is invalid/not found',
    defaultMessage: 'Promocode is invalid',
  },
  promocodeExpired: {
    id: 'promocodeMessages.promocodeExpired',
    description: 'Message of error when a promocode has expired',
    defaultMessage: 'This promo code has expired',
  },
  promocodeUsed: {
    id: 'promocodeMessages.promocodeUsed',
    description: 'Message of error when a promocode was used',
    defaultMessage: 'This promo code is already used',
  },
  applyPromocode: {
    id: 'promocodeMessages.applyPromocode',
    description: 'Text on a button to apply promocode',
    defaultMessage: 'Apply',
  },
  addPromocode: {
    id: 'promocodeMessages.addPromocode',
    description: 'Text on a button to add promocode',
    defaultMessage: 'Add Promocode',
  },
  promocodeAlreadyApplied: {
    id: 'promocodeMessages.promocodeAlreadyApplied',
    description:
      'Hint text for user showing that current subscription already has applied promocode',
    defaultMessage: 'Promocode for current subscription already applied',
  },
  promocodeFieldPlaceholder: {
    id: 'promocodeMessages.promocodeFieldPlaceholder',
    description: 'Default placeholder for Promocode input',
    defaultMessage: 'Promocode',
  },
  promocodeFieldTooLong: {
    id: 'promocodeMessages.promocodeFieldTooLong',
    description: 'Default error for too long promocode input',
    defaultMessage: 'Promocode is too long',
  },
})
